import { isNil } from 'lodash'

const KEY_PREFIX = 'eastcoal_'

const getKey = (key: string) => {
  return key.startsWith(KEY_PREFIX) ? key : `${KEY_PREFIX}${key}`
}

export const localdb = {
  get(key: string, defaultValue?: unknown) {
    const _key = getKey(key)
    const result = localStorage.getItem(_key)

    if (isNil(result)) {
      return defaultValue
    }

    const resultObj = JSON.parse(result)

    if (typeof resultObj === 'object' && 'expireTimestamp' in resultObj) {
      if (resultObj.expireTimestamp < Date.now()) {
        // 已过期
        localdb.rm(_key)
        return undefined
      }
      // 未过期
      return resultObj.value
    }

    return resultObj
  },

  /**
   * 设置本地缓存
   * @param key key
   * @param value 值
   * @param expire 过期时间，单位：秒
   */
  set(key: string, value: unknown, expire?: number) {
    const _key = getKey(key)
    if (!isNil(value)) {
      if (!isNil(expire) && expire > 0) {
        localStorage.setItem(
          _key,
          JSON.stringify({
            value,
            expireTimestamp: Date.now() + expire * 1000
          })
        )
      } else {
        localStorage.setItem(_key, JSON.stringify(value))
      }
    }
  },

  rm(key: string) {
    const _key = getKey(key)
    localStorage.removeItem(_key)
  }
}
